import { Button, Col, Row, Input, DatePicker } from "antd";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import SelectStatus from "../../../components/SelectStatus";
import SelectStatusPayment from "../../../components/SelectStatusPayment";
import UserManualButton from "../../../components/UserManualButton";
const { Search } = Input;

const FilterMenu = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const onSearch = (value) => {
    updateSearchParam("invoice_number", value);
  };
  const onClear = () => {
    updateSearchParam("invoice_number", null);
  };

  const updateSearchParam = (key, value) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value !== null) {
      newSearchParams.set(key, value);
    } else {
      newSearchParams.delete(key);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <>
      <Row
        align="top"
        style={{ marginBottom: "18px" }}
        justify={"space-between"}
        gutter={[8, 8]}
      >
        <Col lg={16} xs={24}>
          <Row gutter={[8, 8]} align={"middle"}>
            <Col lg={6} md={6} sm={12} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2 }}>Status</p>
                <SelectStatusPayment
                  value={searchParams.get("status") || null}
                  onChange={(e) => updateSearchParam("status", e || null)}
                />
              </>
            </Col>
            <Col lg={3} md={4} sm={5} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                  Clear Filter
                </p>
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <Button
                    style={{ width: "100%" }}
                    onClick={() => {
                      setSearchParams({});
                    }}
                  >
                    Clear Filter
                  </Button>
                  <UserManualButton />
                </div>
              </>
            </Col>
          </Row>
        </Col>
        <Col lg={8} xs={24}>
          <Row gutter={[8, 8]} align={"middle"} justify={"end"}>
            <Col xl={12} lg={14} md={6} sm={8} xs={24}>
              <>
                <p style={{ marginBottom: 4, padding: 2, color: "#FFF" }}>
                  Search
                </p>
                <Search
                  placeholder="Input No. Invoice"
                  allowClear
                  defaultValue={searchParams.get("search") || null}
                  onSearch={onSearch}
                  style={{ width: "100%" }}
                  onClear={onClear}
                />
              </>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default FilterMenu;
